import { OrganizationType } from '../types/organization.type';

export const PICKUP_ORDERS_PATH = '/pickup_orders';
export const FLEET_PATH = '/transportation/fleet';

function storedOrganizationType(raw: string | null): OrganizationType | null {
  if (!raw) return null;

  try {
    const value = (JSON.parse(raw) as { organization_type?: unknown }).organization_type;
    return Object.values(OrganizationType).includes(value as OrganizationType)
      ? value as OrganizationType
      : null;
  } catch {
    return null;
  }
}

/** Resolve the first useful ops page for the active organization. */
export function getOpsHomePath(
  organizationType: OrganizationType | null | undefined,
  storedOrganizationJson: string | null = null,
): string {
  const type = organizationType ?? storedOrganizationType(storedOrganizationJson);

  return type === OrganizationType.RECYCLER || type === OrganizationType.TRUCK
    ? FLEET_PATH
    : PICKUP_ORDERS_PATH;
}
